import React from 'react'
import { getUser } from '../../core/localstorage-data';
export const Sbipoints = () => {

    const sbiPoints = getUser().sbiPointBal;
    const sbiToLmr = sbiPoints / 2.4;
    const lmrToRupee = sbiToLmr*0.6;
    
    return (
        <>
        {lmrToRupee>0?
        <div className="text-center m-5 font-bold font-roboto">
        {`You have Rs ${lmrToRupee.toFixed(2)} worth of points in your SBI card. Redeem it today at Max Fashion.`}
        </div>
        :""}
        </>
        
    )
}